import { messages } from '@/constants/messages';
import { MessageInfoType, NoDataErrorType } from '@/types/common';

/**
 * get message error
 * @messageId
 * @messageParams
 * @returns message error
 */
export const getMessageInfo = (
  messageId: string,
  messageParams?: string[]
): MessageInfoType => {
  const result: MessageInfoType = {};
  const message = messages.find((item) => item.MessageID === messageId);
  if (!message) {
    return result;
  }
  result.messageId = messageId;
  result.messageType = getMessageType(messageId);
  result.messageText =
    messageParams && messageParams.length > 0
      ? convertMessage(message.MessageText, messageParams)
      : message.MessageText;
  result.defaultFocus = message.MessageDefault;
  return result;
};

export const convertMessage = (
  message: string,
  messageParams: string[]
): string => {
  let text = message;
  for (let i = 0; i < messageParams.length; i++) {
    text = text.replace(`{${i}}`, messageParams[i]);
  }
  return text;
};

export const getMessageById = (
  messageId: string,
  messageParams?: string[]
): string => {
  const message = messages.find((item) => item.MessageID === messageId);
  if (!message) {
    return '';
  }
  const text =
    messageParams && messageParams.length > 0
      ? convertMessage(message.MessageText, messageParams)
      : message.MessageText;
  return text;
};

export const getMessageType = (messageId: string): string => {
  let type = '';
  const keyword = messageId.slice(3, 4);
  switch (keyword) {
    case 'Q':
      type = 'question';
      break;
    case 'I':
      type = 'info';
      break;
    case 'W':
      type = 'warning';
      break;
    case 'E':
      type = 'error';
      break;
    default:
      type = '';
      break;
  }
  return type;
};

export const noDataError = (): NoDataErrorType => {
  return {
    errorMessages: getMessageById('KI_W008', []),
  };
};

export const clearNoDataError = (): NoDataErrorType => {
  return {
    errorMessages: '',
  };
};
